
import { setCategory, setSetting } from '../containers/client/actions';
import * as _ from 'lodash'

export const categoryDefault = [
  {
    id: 'mac-dinh',
    name: 'Mặc định',
    path: '/home/bang-gia/mac-dinh',
    value: [],
    pinnedRow: [],
    type: 'watchlist',
  },
  {
    name: 'HSX',
    path: '/home/bang-gia/hsx',
    groupName: 'HSX',
    type: 'group',
    value: [],
    pinnedRow: [],
  },
  {
    name: 'VN30',
    path: '/home/bang-gia/vn30',
    groupName: 'HSX',
    type: 'group',
    value: [],
    pinnedRow: [],
  },
  {
    name: 'GD thoả thuận',
    path: '/home/bang-gia/thoa-thuan-hsx',
    groupName: 'HSX',
    type: 'group',
    value: [],
    pinnedRow: [],
  },
  {
    name: 'HNX',
    path: '/home/bang-gia/hnx',
    groupName: 'HNX',
    type: 'group',
    value: [],
    pinnedRow: [],
  },
  {
    name: 'HNX30',
    path: '/home/bang-gia/hnx30',
    groupName: 'HNX',
    type: 'group',
    value: [],
    pinnedRow: [],
  },
  {
    name: 'GD thoả thuận',
    path: '/home/bang-gia/thoa-thuan-hnx',
    groupName: 'HNX',
    type: 'group',
    value: [],
    pinnedRow: [],
  },
  {
    name: 'UPCOM',
    path: '/home/bang-gia/upcom',
    groupName: 'UPCOM',
    type: 'group',
    value: [],
    pinnedRow: [],
  },
  {
    name: 'GD thoả thuận',
    path: '/home/bang-gia/thoa-thuan-upcom',
    groupName: 'UPCOM',
    type: 'group',
    value: [],
    pinnedRow: [],
  },
  {
    name: 'Phái sinh',
    path: '/home/bang-gia/phai-sinh',
    groupName: 'PHAISINH',
    type: 'group',
    value: [],
    pinnedRow: [],
  },
  {
    name: 'Chứng quyền',
    path: '/home/bang-gia/chung-quyen',
    groupName: 'CHUNGQUYEN',
    type: 'group',
    value: [],
    pinnedRow: [],
  },
  {
    name: 'Lô lẻ',
    path: '/home/bang-gia/lo-le',
    groupName: 'LOLE',
    type: 'group',
    value: [],
    pinnedRow: [],
  },
  {
    name: 'HOSE',
    path: '/home/bang-gia/etf-hose',
    groupName: 'ETF',
    type: 'group',
    value: [],
    pinnedRow: [],
  },
  {
    name: 'HNX',
    path: '/home/bang-gia/etf-hnx',
    groupName: 'ETF',
    type: 'group',
    value: [],
    pinnedRow: [],
  },
  {
    name: 'Danh mục ngành',
    path: '/home/bang-gia/danh-muc-nganh',
    groupName: 'NGANH',
    type: 'group',
    value: [],
    pinnedRow: [],
  },
];

export const DMNGANH = [
  {
    id: 3115,
    sequence: 1,
    name: 'Bán lẻ',
    path: '/home/bang-gia/nganh-ban-le',
    symbols:
      'ABS,AFX,AGX,AST,BSC,BTT,CEN,CMV,COM,CPH,DGW,DHT,DKC,FHN,FRT,GEM,HFX,HTM,HTT,IED,KGM,LBC,MWG,PET,PIT,PNG,PSD,SAD,SAS,SBV,TH1,THS,TOP,TTH,TV6,UNM',
  },
  {
    id: 3115,
    sequence: 2,
    name: 'Bảo hiểm',
    path: '/home/bang-gia/nganh-bao-hiem',
    symbols:
      'ABI,AIC,BIC,BLI,BMI,BVH,IFA,MIG,PGI,PRE,PTI,PVI,VNR',
  },
  {
    id: 3115,
    sequence: 3,
    name: 'Bất động sản',
    path: '/home/bang-gia/nganh-bds',
    symbols:
      'AAV,AGG,AMD,API,BCM,BIG,BII,BVL,C21,CCL,CEO,CK8,CKG,CLG,CRE,CRV,D11,D2D,DCH,DIG,DO3,DRH,DTA,DXG,DXS,EFI,FDC,FHH,FID,FIR,FLC,HAR,HD2,HD6,HD8,HDC,HDG,HLD,HPI,HPX,HQC,HRB,HTN,HU6,IDC,IDJ,IDV,IJC,ITA,ITC,KAC,KBC,KDH,KHA,KHG,KOS,KSF,LDG,LEC,LGL,LHG,LMH,LSG,MA1,MEY,MGR,MH3,NBB,NDN,NLG,NRC,NTB,NTC,NTL,NVL,NVT,PDR,PIV,PLA,PPI,PTL,PTN,PV2,PVL,PVR,PWA,PXA,PXC,PXL,QCG,RCL,SCR,SGR,SID,SIP,SJS,SSH,STL,SZB,SZC,SZG,SZL,TBR,TCH,TDC,TDH,TEG,THD,TID,TIG,TIP,TIX,TLD,TN1,V11,V21,VC3,VCR,VGV,VHD,VHM,VIC,VNI,VPH,VPI,VRC,VRE,VRG,XDH',
  },
  {
    id: 3115,
    sequence: 4,
    name: 'Công nghệ Thông tin',
    path: '/home/bang-gia/nganh-cntt',
    symbols:
      'CKV,CMG,CMT,ELC,FPT,HIG,HPT,ICT,ITD,KST,LTC,ONE,PMJ,PMT,POT,SAM,SBD,SGT,SMT,SRA,SRB,ST8,TST,UNI,VAT,VEC,VIE,VLA,VTC,VTE',
  },
  {
    id: 3115,
    sequence: 5,
    name: 'Dầu khí',
    path: '/home/bang-gia/nganh-dau-khi',
    symbols:
      'BSR,OIL,PEQ,PLX,POS,PTV,PVB,PVC,PVD,PVE,PVS,TOS',
  },
  {
    id: 3115,
    sequence: 6,
    name: 'Dịch vụ tài chính',
    path: '/home/bang-gia/nganh-dvtc',
    symbols:
      'AAS,ABW,AGR,APG,APS,ART,BCG,BMS,BSI,BVS,CSI,CTS,DSC,E1VFVN30,EVF,EVS,FIT,FTS,FUCTVGF3,FUCTVGF4,FUCVREIT,FUEDCMID,FUEIP100,FUEKIV30,FUEKIVFS,FUEMAV30,FUESSV30,FUESSV50,FUESSVFL,FUEVFVND,FUEVN100,HAC,HBS,HCM,IBC,IVS,MBS,OGC,ORS,PHS,PSI,SBS,SHS,SSI,TCI,TIN,TVB,TVC,TVS,VCI,VDS,VFS,VIG,VIX,VND,VUA,WSS',
  },
  {
    id: 3115,
    sequence: 7,
    name: 'Điện, nước & xăng dầu khí đốt',
    path: '/home/bang-gia/nganh-dien-nuoc-oil',
    symbols: 'ASP,AVC,BDW,BGW,BHA,BLW,BMF,BNW,BSA,BTP,BTW,BWA,BWE,BWS,CCI,CGC,CHP,CHS,CLW,CMW,CNG,CTW,DDG,DKW,DLM,DMS,DNA,DNC,DNH,DNN,DNW,DRL,DTE,DTK,DTV,DVC,DWC,DWS,GAS,GCB,GDW,GEG,GHC,GLW,GSM,HDW,HFC,HGW,HJS,HNA,HND,HPD,HPW,HTC,HTE,HTW,HWS,ISH,KHP,KHW,KTW,KWA,LAW,LCW,LDW,LKW,LWS,MTG,NAW,NBP,NBT,NBW,ND2,NDW,NLS,NNT,NQB,NQN,NQT,NS2,NSL,NT2,NTH,NTW,NVP,PBK,PCG,PEG,PGC,PGD,PGS,PGV,PIC,PJC,PJS,PMG,PMW,PND,POB,POV,POW,PPC,PPT,PPY,PSH,PTH,PVG,PWS,QNW,QPH,QTP,S4A,SBA,SBH,SEB,SFC,SHP,SII,SJD,SMA,SP2,STW,SVH,TAW,TBC,TBW,TDB,TDG,TDM,TDW,THN,THW,TLP,TMC,TMP,TNW,TOW,TQW,TTE,TVW,UPC,VAV,VCW,VLW,VMG,VPD,VPW,VSH,VWS,VXT,XMP',
  },
  {
    id: 3115,
    sequence: 8,
    name: 'Du lịch và Giải trí',
    path: '/home/bang-gia/nganh-du-lich-giai-tri',
    symbols:
      'ATS,BCV,BLN,BSG,BTV,CTC,DAH,DHQ,DLD,DLT,DNT,DSD,DSN,DSP,DTI,DXL,EIN,GTT,HES,HGT,HHG,HOT,HRT,HVN,KLC,KLF,MAS,MTC,NTG,NWT,ONW,PDC,PGT,RIC,SCS,SGH,SHX,SKG,SRT,STT,TCT,TPS,TSD,TSJ,TTT,VIR,VJC,VNG,VNS,VTD,VTG,VTM,VTR',
  },
  {
    id: 3115,
    sequence: 9,
    name: 'Hàng & Dịch vụ Công nghiệp',
    path: '/home/bang-gia/nganh-dvcn',
    symbols:
      'ABR,ACV,AGE,AME,AMS,APH,APL,ARM,ASG,BAL,BBH,BBS,BMD,BPC,BRS,BTG,BTH,BTU,BXH,CAG,CAR,CAV,CCP,CCR,CCS,CCT,CDH,CDN,CE1,CFM,CIA,CJC,CKA,CKD,CKM,CLL,CMK,CMP,CPI,CTB,CTT,CVP,DAP,DAS,DDH,DDM,DHP,DL1,DNE,DNL,DOP,DPC,DS3,DSV,DTB,DUS,DVP,DXP,DZM,EMC,EME,EMG,EMS,ESL,FBC,FSO,FT1,GEE,GEX,GIC,GMA,GMD,GSP,HAH,HBD,HCT,HDO,HEC,HEM,HEP,HHN,HHR,HKP,HLR,HLS,HMH,HNB,HPB,HSA,HTR,HTV,ILB,ILC,ILS,IME,IMI,INN,IPA,ISG,IST,ITS,KIP,L10,L35,L43,L44,L61,L62,L63,LLM,LM7,LMI,LO5,LPT,LQN,MAC,MBN,MCD,MCP,MDA,MDD,MHC,MIE,MLC,MND,MPY,MQB,MQN,MTB,MTH,MTL,MTS,MTV,MVN,NAG,NAP,NAS,NAU,NCT,NHP,NO1,NOS,NUE,PAC,PAP,PBP,PBT,PCT,PDN,PDV,PEC,PHN,PHP,PJT,PLO,PMP,PMS,PNP,PPE,PPS,PQN,PRC,PSC,PSN,PSP,PTS,PTT,PTX,PVM,PVP,PVT,QHD,QNU,QSP,RAT,REE,SAC,SAL,SCO,SCY,SDA,SDC,SDG,SDK,SDV,SFI,SFN,SGN,SGP,SGS,SHC,SPP,SRF,SSG,STG,STP,STS,SVG,SVI,SWC,SZE,TB8,TBD,TBH,TCL,TCO,TCW,TDP,TGP,THI,THU,TIE,TJC,TKA,TKD,TMS,TNP,TOT,TPP,TR1,TRS,TSB,TSG,TTP,TUG,TV1,TV2,TV4,TVM,TYA,UCT,UDL,UEM,USD,UTT,VBC,VBH,VCM,VCT,VEA,VES,VFC,VFR,VGP,VGR,VHG,VIN,VIP,VLG,VLP,VMS,VMT,VNA,VNC,VNF,VNL,VNT,VOS,VPA,VQC,VSA,VSC,VSE,VSG,VSM,VST,VTB,VTH,VTK,VTO,VTP,VTX,WCS,WTC',
  },
  {
    id: 3115,
    sequence: 10,
    name: 'Hàng cá nhân & Gia dụng',
    path: '/home/bang-gia/nganh-hang-ca-nhan',
    symbols:
      'A32,AAT,ADS,AG1,ASA,BBT,BDG,BEL,BKG,BMG,BVN,CET,CLC,DCG,DCS,DM7,DQC,DTN,EVE,FBA,FTM,G20,GDT,GIL,GLT,GMC,GTD,HCB,HDM,HJC,HLT,HNI,HSM,HTG,HUG,KMR,KSD,LGM,LIX,M10,MGG,MNB,MPT,MSH,NDT,NET,NHT,NJC,NST,NTT,PNJ,PPH,PTG,RAL,SGI,SHE,SPB,SSF,STK,SVD,TCM,TDT,TET,TLG,TLI,TNG,TTG,TVT,VDN,VGG,VGT,VTI,VTJ,X20,X26,XHC,XPH',
  },
  {
    id: 3115,
    sequence: 11,
    name: 'Hóa chất',
    path: '/home/bang-gia/nganh-hoa-chat',
    symbols: 'AAA,APP,BFC,BRC,BRR,BT1,CPC,CSV,DAG,DCM,DDV,DGC,DHB,DOC,DPM,DPR,DRG,DRI,DTT,GER,GVR,HAI,HCD,HII,HNP,HPH,HRC,HSI,HVT,IRC,LAS,LNC,LTG,NFC,NHH,NNG,NSG,PAT,PCE,PCH,PCN,PGN,PHR,PLC,PLP,PMB,PSE,PSW,PVO,QBS,RBC,RDP,RTB,SBR,SEP,SFG,SIV,SJF,SPC,TNC,TPC,TRC,TSC,VAF,VET,VFG,VKP,VNP,VNY,VPS,VTQ,VTZ,VXP',
  },
  {
    id: 3115,
    sequence: 12,
    name: 'Ngân hàng',
    path: '/home/bang-gia/nganh-ngan-hang',
    symbols:
      'ABB,ACB,BAB,BID,BVB,CTG,EIB,HDB,KLB,LPB,MBB,MSB,NAB,NVB,OCB,PGB,SGB,SHB,SSB,STB,TCB,TPB,VAB,VBB,VCB,VIB,VPB',
  },
  {
    id: 3115,
    sequence: 13,
    name: 'Ô tô và phụ tùng',
    path: '/home/bang-gia/nganh-o-to-phu-tung',
    symbols:
      'CMC,CSM,CTF,DRC,FTI,GGG,HAX,HHS,HTL,SRC,SVC,TMT,VKC,VMA,VVS',
  },
  {
    id: 3115,
    sequence: 14,
    name: 'Tài nguyên Cơ bản',
    path: '/home/bang-gia/nganh-tai-nguyen',
    symbols:
      'ACG,ACM,AMC,ATG,BCA,BCB,BKC,BMC,BMJ,BVG,CAP,CBI,CLM,CST,DFC,DHC,DHM,DLG,DPS,DTL,FRC,FRM,GDA,GLC,GTA,GTM,GVT,HAP,HGM,HHP,HLA,HLC,HMC,HMG,HPG,HPM,HSG,HSV,HTS,ITQ,KCB,KHD,KKC,KLM,KMT,KNA,KSB,KSH,KSQ,KSS,KSV,KTL,KVC,LCM,LMC,LTQ,MDC,MDF,MEL,MGC,MHL,MIC,MIM,MSR,MTA,MVB,NBC,NHV,NKG,NSH,PAS,PIS,POM,PTB,RRC,SAV,SHA,SHI,SHN,SMC,SPI,SQC,SSM,SVT,TC6,TCP,TDN,TDS,THT,TIS,TKG,TKU,TLH,TMB,TMG,TMW,TNA,TNB,TNI,TNS,TNT,TQN,TTF,TTS,TVD,TVN,VBG,VCA,VDB,VDT,VGL,VGS,VID,VIF,VIM,VPG,YBM',
  },
  {
    id: 3115,
    sequence: 15,
    name: 'Thực phẩm và đồ uống',
    path: '/home/bang-gia/nganh-thuc-pham-do-uong',
    symbols:
      'AAM,ABT,ACL,AGF,AGM,ANT,ANV,APF,APT,ASM,ATA,ATP,AUM,AVF,BAF,BBC,BBM,BCF,BHG,BHK,BHN,BHP,BKH,BLF,BLT,BMV,BNA,BQB,BSD,BSH,BSL,BSP,BSQ,BTB,C22,CAD,CAF,CAN,CAT,CBC,CBS,CCA,CFV,CLX,CMF,CMM,CMN,CMX,CNA,CPA,CQN,CTP,DAT,DBC,DMN,EPC,FCC,FCS,FGL,FMC,GCF,HAD,HAF,HAG,HAT,HAV,HBH,HCO,HDS,HHC,HKB,HKT,HLB,HLG,HNF,HNG,HNM,HNR,HSL,HVA,HVG,ICF,IDI,IDP,IFS,ILA,JOS,KDC,KHS,KTC,KTS,LAF,LSS,MCF,MCH,MCM,MLS,MML,MPC,MSN,NAF,NCG,NCS,NDF,NGC,NSC,NSS,OCH,PAN,PCF,PRO,PRT,PSL,QHW,QNS,SAB,SAF,SB1,SBL,SBT,SCD,SEA,SGC,SGO,SJ1,SKH,SKN,SKV,SLS,SMB,SNC,SPD,SPH,SPV,SSC,SSN,SST,STD,TAN,TAR,TCJ,TFC,THB,THP,TS4,TVO,VCF,VDL,VHC,VHF,VLC,VLF,VNH,VNM,VOC,VSF,VSN,VTL,WSB',
  },
  {
    id: 3115,
    sequence: 16,
    name: 'Truyền thông',
    path: '/home/bang-gia/nganh-truyen-thong',
    symbols:
      'ADC,ADG,ALT,BDB,BED,BST,CAB,DAD,DAE,DST,EBS,ECI,EID,EPH,FHS,FOC,HEV,HHI,HTP,IBD,IHK,IN4,LBE,NBE,ODE,PNC,QST,RGC,SAP,SED,SGD,SMN,STC,STH,SUM,TPH,VEF,VNB,VNX,VNZ,VPR,YEG',
  },
  {
    id: 3115,
    sequence: 17,
    name: 'Viễn thông',
    path: '/home/bang-gia/nganh-vien-thong',
    symbols:
      'ABC,FOX,MFS,PAI,PIA,PTP,TTN,VGI',
  },
  {
    id: 3115,
    sequence: 18,
    name: 'Xây dựng và Vật liệu',
    path: '/home/bang-gia/nganh-xay-dung-vat-lieu',
    symbols:
      'ACC,ACE,ACS,ADP,ALV,ATB,B82,BAX,BCC,BCE,BCO,BDT,BGT,BHC,BHT,BMN,BMP,BOT,BT6,BTD,BTN,BTS,C12,C32,C36,C47,C4G,C69,C71,C92,CC1,CC4,CCD,CCM,CCV,CDC,CDG,CDO,CDR,CEG,CGV,CH5,CHC,CI5,CID,CIG,CII,CIP,CLH,CMD,CMI,CMS,CNN,CNT,CQT,CRC,CSC,CT3,CT6,CTA,CTD,CTI,CTN,CTR,CTX,CVT,CX8,CYC,DAC,DBV,DC1,DC2,DC4,DCF,DCR,DCT,DFF,DGT,DHA,DIC,DID,DIH,DLR,DND,DNP,DPG,DSG,DTC,DTD,DTJ,DVG,DVW,DXV,E12,E29,EIC,EVG,FCM,FCN,FIC,FVN,G30,G36,GAB,GH3,GKM,GMH,GMX,GND,GTH,GTS,H11,HAM,HAN,HAS,HBC,HC1,HC3,HCC,HCI,HDA,HEJ,HFB,HHV,HID,HLY,HMR,HMS,HNC,HOM,HPP,HSP,HT1,HT9,HTI,HU1,HU3,HU4,HUB,HUT,HVH,HVX,HWI,ICC,ICG,ICI,ICN,INC,KCE,KDM,KHL,KPF,KTT,L12,L14,L18,L40,L45,LAI,LBM,LCC,LCD,LCG,LCS,LG9,LGC,LHC,LIC,LIG,LM3,LM8,LUT,MBG,MCC,MCG,MCI,MCO,MDG,MEC,MES,MST,MT9,MVC,NAC,NAV,NDX,NED,NHA,NHC,NNC,NTP,NXT,PC1,PCC,PCM,PDB,PEN,PFL,PHC,PHH,PID,PLE,PNT,PSB,PSG,PTC,PTD,PTE,PTO,PVA,PVH,PVV,PVX,PVY,PX1,PXI,PXK,PXM,PXS,PXT,QCC,QNC,QNT,QTC,RCC,RCD,REN,ROS,S12,S27,S55,S72,S74,S96,S99,SBM,SC5,SCC,SCG,SCI,SCJ,SCL,SD1,SD2,SD3,SD4,SD5,SD6,SD7,SD8,SD9,SDB,SDD,SDJ,SDN,SDP,SDT,SDU,SDX,SDY,SGV,SHG,SIC,SIG,SJC,SJE,SJG,SJM,SNZ,SVN,TA3,TA6,TA9,TBT,TBX,TCD,TCK,TCR,TDF,TDI,TED,TEL,TGG,THG,THO,TKC,TL4,TLT,TMX,TNM,TRT,TS3,TTA,TTB,TTC,TTL,TTZ,TV3,TVA,TVG,TVH,TXM,UDC,UDJ,UIC,UMC,USC,V12,V15,V45,VC1,VC2,VC5,VC6,VC7,VC9,VCC,VCE,VCG,VCP,VCS,VCX,VE1,VE2,VE3,VE4,VE8,VE9,VGC,VHH,VHL,VIH,VIT,VIW,VLB,VMC,VNE,VPC,VSI,VTA,VTS,VTV,VVN,VW1,VW3,VXB,X77,XDC,XLV,XMC,XMD,YBC',
  },
  {
    id: 3115,
    sequence: 19,
    name: 'Y tế',
    path: '/home/bang-gia/nganh-y-te',
    symbols:
      'AGP,AMP,AMV,APC,BCH,BCP,BIO,CBV,CDP,CNC,CVN,DAN,DBD,DBM,DBT,DCL,DDN,DHD,DHG,DHN,DMC,DMH,DNM,DP1,DP2,DP3,DPH,DPP,DTG,DTH,DTP,DVM,DVN,GPC,HDP,IMP,JVC,LDP,MED,MEF,MKP,MKV,MRF,MTP,NDC,NDP,NTF,OPC,PBC,PMC,PPP,SPM,TNH,TRA,TTD,TVP,TW3,UPH,VDP,VHE,VMD,YTC',
  },
];

const setting = {
  typeIndex: 1,
  symbolMinimize: [],
};

export function getCategory({ dispatch }) {
  const storedCategory = loadState('category');

  console.log(storedCategory)
  const _uniq = _.uniqBy(storedCategory, 'path')
  console.log(_uniq)
  if (storedCategory) {
    dispatch(setCategory(_uniq));
  } else {
    // chưa có category
    dispatch(setCategory(categoryDefault));
    saveState('category', categoryDefault);
  }
  return true;
}

export const getSetting = ({ dispatch }) => {
  const storedSetting = loadState('setting');

  if (storedSetting) {
    dispatch(setSetting(storedSetting));
  } else {
    // chưa có category
    dispatch(setSetting(setting));
    saveState('setting', setting);
  }

  return true;
};

export const loadState = (key) => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (key, state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(key, serializedState);
  } catch {
    // ...
  }
};
